import { useUnsplashImages } from 'hooks/queries/useUnsplashImages'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'
import { BackgroundAssetProps } from './Types'
import { Grid } from './Grid'
import { Preview } from './SuggestedCategory/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

interface Props {
  query: string
  onSelect: (assetProps: BackgroundAssetProps) => void
  seeds?: Array<Preview>
}

const Search = observer(({ query, onSelect, seeds = [] }: Props) => {
  const { data, hasNextPage, fetchNextPage } = useUnsplashImages({ query, perPage: 24 })
  const { isMobile } = useResponsiveDesign()
  const { drawersStore } = useRootStore()

  const unsplashResults = (data?.pages || []).flatMap((page) =>
    page?.type === 'success' ? (page.data.results || page.data) ?? [] : [],
  )

  return (
    <Grid.Root>
      {seeds.map((seed) => (
        <Grid.Cell key={seed.src}>
          <Grid.Thumbnail
            onClick={() => {
              onSelect({
                src: seed.src,
                w: seed.width,
                h: seed.height,
                mimeType: 'image/png',
              })
              if (isMobile) drawersStore.resetSnap()
            }}
          >
            <img src={seed.src} alt={seed.alt || ''} />
          </Grid.Thumbnail>
        </Grid.Cell>
      ))}
      {unsplashResults.map((result) => (
        <Grid.Cell key={result.id}>
          <Grid.Thumbnail
            onClick={() => {
              onSelect({
                src: result.urls.regular,
                w: result.width,
                h: result.height,
                mimeType: 'image/jpeg',
              })
              if (isMobile) drawersStore.resetSnap()
            }}
          >
            <img src={result.urls.thumb} alt={result.alt_description || ''} />
          </Grid.Thumbnail>
        </Grid.Cell>
      ))}
      {hasNextPage && <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage} />}
    </Grid.Root>
  )
})

export { Search }
